import React, { useState } from "react";
import "./Faqs.css";

const faqs = [
  {
    q: "What is the difference between an HMO and a PPO?",
    a: "HMO plans require you to use doctors within a specific network and need referrals to see specialists. PPOs offer more flexibility to see providers in or out of network without referrals.",
  },
  {
    q: "What is a deductible?",
    a: "A deductible is the amount you must pay out of pocket for covered services before your insurance begins to pay.",
  },
  {
    q: "What is coinsurance?",
    a: "Coinsurance is the percentage of costs you share with your insurance company after you’ve met your deductible.",
  },
  {
    q: "What is a copay?",
    a: "A copay is a fixed amount you pay for a covered service at the time of care, like $25 for a doctor’s visit.",
  },
  {
    q: "Does insurance cover pre-existing conditions?",
    a: "Yes, under the Affordable Care Act, most health plans cannot deny coverage or charge more due to pre-existing conditions.",
  },
  {
    q: "When can I enroll in health insurance?",
    a: "Most enrollments happen during Open Enrollment, but you may qualify for a Special Enrollment Period due to life events like job loss or marriage.",
  },
  {
    q: "What is out-of-pocket maximum?",
    a: "It’s the most you’ll have to pay for covered services in a year. Once reached, your insurance pays 100% of covered services.",
  },
  {
    q: "Is dental insurance included in health plans?",
    a: "Typically, no. Dental coverage is often offered as a separate policy unless bundled in certain family or employer plans.",
  },
  {
    q: "What’s the penalty for not having health insurance?",
    a: "There is no longer a federal penalty, but some states have their own requirements and penalties.",
  },
  {
    q: "What does Medicare not cover?",
    a: "Medicare does not cover long-term care, most dental care, hearing aids, and vision exams or eyeglasses.",
  },
  {
    q: "Do I need life insurance if I’m young and healthy?",
    a: "Yes, buying early can lock in lower rates. Life insurance can help with debt, final expenses, and support your dependents.",
  },
  {
    q: "What is supplemental insurance?",
    a: "It provides additional coverage or cash benefits for expenses not fully covered by your primary health insurance.",
  },
  {
    q: "What are annuities in insurance?",
    a: "Annuities are financial products that provide guaranteed income, often used for retirement planning.",
  },
  {
    q: "Can I keep my doctor with a new plan?",
    a: "It depends on the plan’s network. PPOs offer more flexibility, while HMOs often restrict you to specific providers.",
  },
  {
    q: "Are vision and dental covered under Medicare?",
    a: "Traditional Medicare does not cover routine dental or vision. You’ll need separate plans or Medicare Advantage options.",
  },
  {
    q: "What is a premium?",
    a: "A premium is the amount you pay each month to maintain your insurance coverage.",
  },
  {
    q: "What’s the difference between term and whole life insurance?",
    a: "Term life provides coverage for a set period (10, 20, 30 years). Whole life lasts your entire life and builds cash value.",
  },
  {
    q: "Can I change my plan mid-year?",
    a: "Only if you experience a qualifying life event, such as getting married, having a baby, or losing other coverage.",
  },
  {
    q: "What is a network?",
    a: "A network is a group of healthcare providers and facilities that have agreed to provide services at discounted rates to plan members.",
  },
  {
    q: "How do I file a claim?",
    a: "Many providers file claims for you. If not, you’ll submit a claim form with itemized receipts to your insurance company.",
  },
];

function Faqs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <section className="faq-page">
        <h1>Frequently Asked Questions</h1>
        <div className="faq-list">
          {faqs.map((item, index) => (
            <div
              key={index}
              className={`faq-item ${openIndex === index ? "open" : ""}`}
            >
              <button className="faq-question" onClick={() => toggleFaq(index)}>
                {item.q}
              </button>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{item.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Faqs;
